import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'baseui/snackbar'
import { useTranslation } from 'react-i18next'

import { selectCacheStoreData } from './cacheSelectors'
import { setCacheKey } from './cacheSlice'
import { cacheActions } from './cacheSagas'

const useCache = () => {
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()
  const { t } = useTranslation('devToolsNew')

  const { cacheKey, value, isEmpty, isSearching, error } = useSelector(selectCacheStoreData)

  const onCacheKeyChange = value => dispatch(setCacheKey(value))

  const onSearch = () => {
    if (!cacheKey) return
    dispatch({
      type: cacheActions.SEARCH,
      enqueue,
      t,
      payload: { cacheKey },
    })
  }

  return {
    form: {
      cacheKey,
      value,
      isEmpty,
      isSearching,
      error,
      onCacheKeyChange,
      onSearch,
    },
    t,
  }
}

export default useCache
